export const QUERY__MARKETPLACE_ITEMS = 'marketplace-items';
